import { Component, Input } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
    selector: 'loading-overlay',
    templateUrl: './loadingOverlay.component.html',
    styleUrls: ['./loadingOverlay.component.css'],
    animations: [
        trigger('loading', [
            state('off', style({
                "opacity": "0",
                "display": "none"
            })),
            state('on', style({
                "opacity": "1",
                "display": "block"
            })),
            transition('off => on', animate('300ms ease-in')),
            transition('on => off', animate('300ms ease-out'))
        ])
    ],
    standalone: false
})
export class LoadingOverlayComponent {
    private mState: string = 'off';

    public get state(): string {
        return this.mState;
    }

    @Input()
    public set show(value: boolean) {
        this.mState = value ? 'on' : 'off';
    }
}